/// <reference types="office-js" />
import { escapeHtmlForDocument } from "./replaceStatements";
declare const Word: any;

export interface DocumentContent {
  html: string;
  styles?: any[];

  metadata: {
    title: string;
    author: string;
  };
}

export async function extractDocumentContent(): Promise<DocumentContent> {
  return Word.run(async (context: any) => {
    const document = context.document;
    const body = document.body;

    const docProperties = document.properties;
    docProperties.load("title, author");
    body.load("text, paragraphs, font, style");

    const paragraphs = body.paragraphs;
    paragraphs.load("text, font, style, alignment");

    await context.sync();

    const textContent = body.text;

    const styles: any[] = [];
    for (const para of paragraphs.items) {
      const paraFont = para.font;
      paraFont.load("name, size, bold, italic, underline");
      await context.sync();

      styles.push({
        text: para.text,
        fontName: paraFont.name,
        fontSize: paraFont.size,
        bold: paraFont.bold,
        italic: paraFont.italic,
        underline: paraFont.underline,
        alignment: para.alignment,
        style: para.style,
      });
    }

    let htmlContent = "";
    for (const style of styles) {
      const escapedText = escapeHtmlForDocument(style.text);
      let styleAttr = "";
      if (style.fontName) styleAttr += `font-family: ${style.fontName}; `;
      if (style.fontSize) styleAttr += `font-size: ${style.fontSize}pt; `;
      if (style.bold) styleAttr += `font-weight: bold; `;
      if (style.italic) styleAttr += `font-style: italic; `;
      if (style.underline && style.underline !== "None") styleAttr += `text-decoration: underline; `;
      if (style.alignment) styleAttr += `text-align: ${style.alignment.toLowerCase()}; `;
      const className = style.style ? style.style.replace(/\s+/g, "-").toLowerCase() : "normal";
      htmlContent += `<p class="${className}"${styleAttr ? ` style="${styleAttr.trim()}"` : ""}>${escapedText}</p>`;
    }

    const metadata = {
      title: docProperties.title || "Untitled Document",
      author: docProperties.author || "Unknown Author",
    };

    return {
      html: htmlContent,
      metadata,
    };
  });
}